import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-117" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto w-full max-w-narrow px-5 text-center md:px-8" data-id="element-118" data-mp="1o3dj01a9xtlv">
        <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-2xl bg-blue-50 ring-1 ring-blue-100" data-id="element-119" data-mp="2223lxxjryni5">
          <ShieldCheckIcon className="h-10 w-10 text-blue-600" aria-hidden="true" data-id="element-120" data-mp="1x28spncj1ltx" />
        </span>

        <h2 className="mt-7 font-display text-[2rem] font-extrabold leading-tight tracking-tight text-ink md:text-5xl" data-id="element-121" data-mp="19co7sywtcei0">
          Garantía 7 días — sin preguntas
        </h2>

        <div className="mt-9 rounded-2xl bg-blue-50 px-6 py-9 ring-1 ring-blue-100 md:px-10" data-id="element-122" data-mp="1j5c0piko9ybg">
          <p className="text-lg text-ink md:text-xl" data-id="element-123" data-mp="1ed279skcmg4f">Descargás los tomos. Los usás en casa.</p>
          <p className="mt-3 text-lg text-ink md:text-xl" data-id="element-124" data-mp="qmyeyhcm22sq">Si en 7 días no es lo que esperabas:</p>
          <p className="mt-6 font-display text-3xl font-extrabold tracking-tight text-blue-600 md:text-4xl" data-id="element-125" data-mp="lo4x6cqajpmr">
            devolución del 100%
          </p>
          <p className="mt-3 text-lg font-semibold text-ink md:text-xl" data-id="element-126" data-mp="tymgk4fw3gx4">sin formularios, sin drama.</p>
        </div>

        <p className="mt-6 text-sm text-blue-900/55" data-id="element-127" data-mp="yot564aej1fd">Tasa de devoluciones: menos del 1%.</p>
      </div>
    </section>;
}